module.exports = __webpack_public_path__ + "assets/img/Type E (42).284e4e33.jpg";